// Global site configuration — single switch between teaser and launch modes.
// Flip REACT_APP_SITE_MODE to "launch" (and fill LAUNCH_ASSETS) once official
// hardware renders exist. No redesign required.
import { LAUNCH_DATE_UTC } from "./ivory-assets";

export const SITE_MODE = (process.env.REACT_APP_SITE_MODE || "teaser").toLowerCase();
export const IS_TEASER = SITE_MODE !== "launch";

export { LAUNCH_DATE_UTC };
export const PRESALE_DATE_LABEL = "Coming soon";
export const REVEAL_WINDOW_LABEL = "Coming soon";

// Official launch assets — populated when SITE_MODE flips to "launch".
export const LAUNCH_ASSETS = {
  revealHero: "",
  finishes: {
    obsidian_black: "",
    champagne_gold: "",
    chrome_silver: "",
  },
};
